import * as d3 from 'd3'
export default {

  methods: {

    gauge_Plan() {

      let angle = this.angle
      let col = this.columns.find(f=> f.code == 'PLAN')
      let prog = this.rawData[col.code]/100
      let fc = 270 + prog * 180

      let plan = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)

      plan
      .append('line')
      .attr('x1', 0).attr('y1', -this.circle.radius - 10)
      .attr('x2', 0).attr('y2', angle.inY)
      .attr('stroke', col.stroke).attr('stroke-width', 1)
      .attr('transform', () => `rotate(${270}, 0, 0)`)
      .transition().duration(500)
      .attr('transform', () => `rotate(${fc}, 0, 0)`)

      plan
      .append('circle')
      .attr('cx', 0).attr('cy', -this.circle.radius - 10)
      .attr('r', 2).attr('fill', 'white')
      .attr('stroke', col.stroke).attr('stroke-width', 1)
      .attr('transform', () => `rotate(${270}, 0, 0)`)
      .transition().duration(500)
      .attr('transform', () => `rotate(${fc}, 0, 0)`)


      let cx = (this.circle.radius + 10) * Math.sin((180-fc) * Math.PI/180)
      let cy = (this.circle.radius + 10) * Math.cos((180-fc) * Math.PI/180)

      let value = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)

      value
      .append('text')
      .attr('transform', ()=> {
        let tr = ''
        if(prog <= .35) tr = `translate(${cx-5}, ${cy + col.tSize*0.4})`
        if(prog >= .65) tr = `translate(${cx+5}, ${cy + col.tSize*0.4})`
        if(prog > .35 && prog < .65) tr = `translate(${cx}, ${cy-9 + col.tSize*0.4})`
        return tr
      })
      .attr('font-size', col.tSize).attr('fill', col.tColor)
      .attr('text-anchor', ()=> {
        let align = ''
        if(prog <= .35) align = 'end'
        if(prog >= .65) align = 'start'
        if(prog > .35 && prog < .65) align = 'middle'
        return align
      })
      .attr('opacity', 0)
      .text(this.rawData[col.code] + col.unit)
      .transition().duration(500).attr('opacity', 1)
    },

  }
}